import { StyledLink } from 'Features/ClickceaseMigrationBanner/ClickceaseMigrationBanner.styled'
import React, { useRef } from 'react'
import { getZendeskLinkAndToken } from 'src/hooks/zendesk/api/getZendeskUrl'
import { useUserStore } from 'Stores/userStoreModuleFed'

interface HelpCenterRedirectProps {
  text: string
  article: string
}

export const HelpCenterRedirect = ({ text, article }: HelpCenterRedirectProps) => {
  const { userId } = useUserStore()

  const formRef = useRef<HTMLFormElement>(null)
  const jwtInputRef = useRef<HTMLInputElement>(null)
  const returnToInputRef = useRef<HTMLInputElement>(null)

  const handleClick = (article: string) => {
    getZendeskLinkAndToken(userId)
      .then((response) => {
        if (!(response instanceof Error) && response?.data) {
          if (jwtInputRef?.current && formRef) {
            jwtInputRef.current.value = response.data.jwt
          }

          if (returnToInputRef?.current && formRef) {
            const url = new URL(response.data.return_to)
            if (article) url.pathname = url.pathname + '/' + article.replace(/^\//, '')
            returnToInputRef.current.value = article
          }

          if (formRef.current) {
            formRef.current.action = response.data.jwt_req_url
            formRef.current.submit()
          }
        }
      })
      .catch((err: Error) => console.error(err))
  }

  return (
    <>
      <StyledLink onClick={() => handleClick(article)}>{text}</StyledLink>
      <form ref={formRef} method="post" style={{ display: 'none' }}>
        <input ref={jwtInputRef} type="hidden" name="jwt"></input>
        <input ref={returnToInputRef} type="hidden" name="return_to"></input>
      </form>
    </>
  )
}
